import { propertyQueryKeys as e } from "./usePropertiesQueryKeys.mjs";
import { useInfiniteListQuery as t } from "@maat/store-hooks";
import { propertiesApi as n } from "@maat/api-main";
//#region src/properties/useHostPropertiesQuery.ts
var r = (r, i) => t({
	queryKey: e.hostFeed({
		scope: "host",
		...r
	}),
	fetchPage: (e) => n.getHostProperties({
		...r,
		page: e
	}),
	key: "properties",
	enabled: i?.enabled ?? !0
});
//#endregion
export { r as useHostPropertiesQuery };
